const SvgIcon = ({ size = '24', color = '#55fa79' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      strokeWidth="1"
      d="M7.059 14h6.588v1.647H7.059Zm0-4.117h9.882v1.647H7.06Zm0 8.235h4.117v1.647H7.06Z"
    ></path>
    <path
      fill={color}
      strokeWidth="1"
      d="M19.508 2.571h-2.503v-.857c0-.454-.175-.89-.488-1.212A1.65 1.65 0 0 0 15.337 0H8.663c-.442 0-.867.18-1.18.502a1.74 1.74 0 0 0-.488 1.212v.857H4.492c-.443 0-.867.181-1.18.503a1.74 1.74 0 0 0-.488 1.212v18c0 .454.175.89.488 1.212S4.05 24 4.492 24h15.016c.442 0 .867-.18 1.18-.502s.488-.758.488-1.212v-18c0-.455-.175-.891-.488-1.212a1.65 1.65 0 0 0-1.18-.503M8.663 1.714h6.674v3.429H8.663Zm10.845 20.572H4.492v-18h2.503v2.571h10.01V4.286h2.503z"
    ></path>
  </svg>
);

export default SvgIcon;
